var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main_page"},[(_vm.header_show)?_c('topHeader'):_vm._e(),_c('div',{class:[_vm.header_show ?'common-scrollbar' :'' ]},[_c('div',{staticClass:"home-content"},[_c('router-view',{on:{"header":_vm.header,"footer":_vm.footer}})],1),(_vm.footer_show)?_c('bottomFooter'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }